let socket = null

function init (_socket) {
  socket = _socket
}

function disconnect () {
  socket = null
}

window.socket = socket

export {
  socket,
  init,
  disconnect,
}
